export default [
  {
    path: '/listening-topic',
    component: () => import('./views/Index'),
    name: 'listening-topic',
    redirect: { name: 'listening-topic-list' },
    children: [
      {
        path: '',
        name: 'listening-topic-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: 'detail/:topic_id',
        name: 'listening-topic-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
